import {WASS} from "../Constantes";

export const iniciarChatWass = ({mensaje='Hola Hotel Mar Azul', numero=WASS}) =>{
    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`
    window.open(link)
}